import { Button } from "components/Form/Button";
import { Modal } from "components/Modal";
import { memo } from "react";

interface EmailVerifiedModalProps {
  show: boolean;
  onClose: () => void;
}

export const EmailVerifiedModal = memo(function EmailVerifiedModal({
  show,
  onClose,
}: EmailVerifiedModalProps) {
  return (
    <Modal show={show} onClose={onClose}>
      <div className="text-center space-y-6 p-4">
        {/* Success Icon */}
        <div className="flex justify-center">
          <div className="w-20 h-20 rounded-full bg-blue-500 flex items-center justify-center">
            <svg
              className="w-12 h-12 text-white"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={3}
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
        </div>

        {/* Success Message */}
        <div>
          <p className="text-18 text-gray-700">
            Your email has been successfully verified 🎉
          </p>
        </div>

        {/* Done Button */}
        <Button type="button" onClick={onClose} className="w-full">
          Done
        </Button>
      </div>
    </Modal>
  );
});
